<template>
  <LangRouterLink
    :to="route"
    :class="[
      'navbar__desktop-link',
      category ? color(category.color) : '',
      { '-active': isActive },
    ]"
    :style="{ '--nav-item-delay': `${enterDelay}ms` }"
    @mouseenter="updateActiveCategory"
    :title="label"
  >
    {{ label }}
  </LangRouterLink>
</template>

<script>
import { LangRouterLink } from '@/components/global'
import { color } from '@/helpers'
import { HasCategory } from '@/mixins'

export default {
  name: 'DesktopMenuItem',
  mixins: [HasCategory],
  props: {
    content: {
      type: Object,
      required: true,
    },
    enterDelay: {
      type: Number,
      default: 0,
    },
  },
  components: { LangRouterLink },
  data() {
    return {
      currentActive: false,
    }
  },
  computed: {
    category() {
      return this.content.category ? this.getCategory(this.content.category) : null
    },
    isActive() {
      return (
        this.$store.state.navigation.category &&
        this.$store.state.navigation.category.id === this.content.category
      )
    },
    route() {
      return this.content.route !== 'category'
        ? { name: this.content.route }
        : { name: this.content.route, params: { slug: this.category.slug } }
    },
    label() {
      return this.content.route !== 'category'
        ? this.$t(`navigation.${this.content.route}`)
        : this.category.title
    },
  },
  methods: {
    color,
    updateActiveCategory() {
      this.$store.dispatch('updateActiveCategory', this.category)
    },
  },
}
</script>
